
import RequestService from '../request-service';

/**
 * Language Request Service
 */
export default class LanguageRequestService extends RequestService {
  /**
   * Class constructor method
   */
  constructor() {
    super();
    /**
     * Set endpoint
     * @type {string}
     */
    this.endpoint = this.$config.endpoints.languageResource;
    /**
     * Set request method type
     * @type {string}
     */
    this.method = 'get';

    /**
     * Set get params
     * @type {{}}
     */
    this.headers = null;
    this.addGetParam('Culture', this.$config.defaultHeaders.Culture);
  }

  /**
   * re-map data from the response to match the translation engine string resources structure
   * @param data {object}
   * @return {object}
   */
  fillData(data) {
    let output = {};
    let stringKeys = Object.keys(data);
    stringKeys.forEach((key) => {
      output[key.toLowerCase()] = data[key];
    });
    return output;
  }

  getNewLanguage($translate) {
    this.execute((resp) => {
      let stringTranslations = {};
      // map API data with proper language model
      stringTranslations[APP_SETTINGS.player.language] = this.fillData(resp.data.res);
      // languageId global variable
      window.btoLangId = typeof resp.data.LanguageId !== 'undefined' ? resp.data.LanguageId : resp.data.id;
      // Culture info, global variable for SportCast culture
      if (resp.data.ci) {
        window.sportCastCulture = resp.data.ci;
      }
      // set application language
      $translate.setLang(APP_SETTINGS.player.language);
      // set application string resources
      $translate.setLocales(stringTranslations);
    });
  }
}
